"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TENANT_STRUCTURES = exports.CREATE_TENANT_MODAL_KEY = exports.ALL_TENANTS_NUMBER = exports.TENANTS_STATE_KEYS = exports.TENANTS_STATE_KEY_NAME = void 0;
var TENANTS_STATE_KEY_NAME = 'tenants';
exports.TENANTS_STATE_KEY_NAME = TENANTS_STATE_KEY_NAME;
var TENANTS_STATE_KEYS = {
  CREATE_TENANT: 'createTenant',
  UPDATE_TENANT: 'updateTenant',
  LIST: 'list',
  ALL: 'all'
};
exports.TENANTS_STATE_KEYS = TENANTS_STATE_KEYS;
var ALL_TENANTS_NUMBER = 100000000;
exports.ALL_TENANTS_NUMBER = ALL_TENANTS_NUMBER;
var CREATE_TENANT_MODAL_KEY = 'create-tenant-modal';
exports.CREATE_TENANT_MODAL_KEY = CREATE_TENANT_MODAL_KEY;
var TENANT_STRUCTURES = {
  TREE: 'tree',
  FLAT: 'flat'
};
exports.TENANT_STRUCTURES = TENANT_STRUCTURES;
//# sourceMappingURL=constants.js.map